<template>
  <div id="coupon" :style="couponInfo.couponType==='mycoupon'?'width:354px':'width:294px'">
    <!-- 我的礼卷 -->
    <div
      v-if="couponInfo.couponType==='mycoupon'"
      :class="couponInfo.couponState===0?'coupon_bck_success':'coupon_bck_fail'"
      class="coupon_content"
    >
      <div class="coupon_price">
        <div class="coupon_price_content">
          <span>¥</span>
          {{couponInfo.price}}
        </div>
      </div>
      <div class="coupon_info" style="width:252px;">
        <div class="coupon_infoup">
          <div class="coupon_info_content">
            <h4 :class="couponInfo.couponState===0?'coupon_title':'nocoupon_title'">{{couponInfo.title}}</h4>
            <div :class="couponInfo.couponState===0?'coupon_date':'nocoupon_date'">{{couponInfo.date}}</div>
            <div :class="couponInfo.couponState===0?'coupon_use':'nocoupon_use'">{{use}}</div>
          </div>
          <div class="coupon_state">
            <img :src="toUsed" alt v-if="couponInfo.couponType==='mycoupon'&&couponInfo.couponState===0" />
            <img :src="used" alt v-if="couponInfo.couponType==='mycoupon'&&couponInfo.couponState===1" />
            <img :src="overdue" alt v-if="couponInfo.couponType==='mycoupon'&&couponInfo.couponState===2" />
          </div>
        </div>
      </div>
    </div>
    <!-- 确认订单礼卷 -->
    <div
      v-else-if="couponInfo.couponType==='confirm'"
      :class="couponInfo.couponState===0?'coupon_narrowbck_success':'coupon_narrowbck_fail'"
      class="coupon_content"
    >
      <div class="coupon_price">
        <div class="coupon_price_content">
          <span>¥</span>
          {{couponInfo.price}}
        </div>
      </div>
      <div class="coupon_info" style="width:192px">
        <div class="coupon_infoup" style="margin-top: 7px;">
          <div class="coupon_info_content">
            <h4 :class="couponInfo.couponState===0?'coupon_title':'nocoupon_title'">{{couponInfo.title}}</h4>
            <div :class="couponInfo.couponState===0?'coupon_date':'nocoupon_date'">{{couponInfo.date}}</div>
            <div :class="couponInfo.couponState===0?'coupon_use':'nocoupon_use'">{{use}}</div>
          </div>
        </div>
        <div class="coupon_button" v-if="couponInfo.couponType==='confirm'">
          <div class="coupon_btn" v-if="couponInfo.pickType===0">
            <slot name="pick"></slot>
            <!-- <img :src="pick" alt="">
            <img :src="nopick" alt="">-->
          </div>
        </div>
      </div>
    </div>
    <!-- warnState  0是显示  1是不显示 -->
    <div :class="couponInfo.couponState===0?'coupon_warn':'nocoupon_warn'" v-if="couponInfo.warnState===0">
      <p>{{couponInfo.warn}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    couponInfo: Object

    // couponState: Number,
    // price: String,
    // date: String,
    // title: String,
    // warn: String,
    // couponType: String,
    // warnState: Number
  },
  data () {
    return {
      // couponType: 'mycoupon', // confirm, mycoupon
      // couponState: 3, // 1是待用  2是已使用 3是过期
      // price: '2000',
      // date: '2020.03.21-2020.06.3',
      // title: '强基计划重难程专用券用券',
      use: '不可与拼团、联报活动叠加',
      // warn:
      //   '适用范围：直播课、线下班可用直播课、线播课、线下班可用直播课、线下班可用直播课、线下班可用直播课、线下班可用直播课、线下班可用直播课、线下班可用直下班可用直播课、线下班直播课、线下班可用',
      toUsed: require('@/assets/img/coupon/logo_daishiyong@2x.png'),
      used: require('@/assets/img/coupon/logo_yishiyong@2x.png'),
      overdue: require('@/assets/img/coupon/logo_yiguoqi@2x.png'),
      pick: require('@/assets/img/coupon/pick.png'),
      nopick: require('@/assets/img/coupon/nopick.png')
    }
  },
  created () {}
}
</script>
<style scoped lang="scss">
#coupon {
  .coupon_bck_success {
    background: url("../assets/img/coupon/bg_orange.png") no-repeat;
  }
  .coupon_bck_fail {
    background: url("../assets/img/coupon/bg_grey.png") no-repeat;
  }
  .coupon_narrowbck_success {
    background: url("../assets/img/coupon/bg_orange_small.png") no-repeat;
  }
  .coupon_narrowbck_fail {
    background: url("../assets/img/coupon/bg_grey_small.png") no-repeat;
  }
  .coupon_content {
    display: flex;
    height: 100px;
    position: relative;
    z-index: 1;
    .coupon_price {
      width: 102px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 30px;
      span {
        font-size: 16px;
        margin-right: -3px;
      }
    }
    .coupon_info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .coupon_button {
        display: flex;
        height: 20px;
        justify-content: flex-end;
        box-sizing: border-box;
        padding: 0px 8px 0px 0px;
        .coupon_btn {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: white;
        }
      }
      .coupon_infoup {
        display: flex;
        align-items: center;
        justify-content: center;
        .coupon_state{
          img{
            width: 66px;
          }
        }
        .coupon_info_content {
          .coupon_title {
            font-size: 14px;
            height: 14px;
            line-height: 14px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }
          .nocoupon_title {
            font-size: 14px;
            height: 14px;
            line-height: 14px;
            font-weight: 600;
            color: rgba(51, 51, 51, 0.3);
          }
          .coupon_date {
            font-size: 12px;
            color: rgba(51, 51, 51, 0.6);
            height: 12px;
            line-height: 12px;
            margin-top: 8px;
            font-weight: 400;
          }
          .nocoupon_date {
            font-size: 12px;
            color: rgba(51, 51, 51, 0.18);
            height: 12px;
            line-height: 12px;
            margin-top: 8px;
            font-weight: 400;
          }
          .coupon_use {
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(51, 51, 51, 0.6);
            line-height: 12px;
            margin-top: 14px;
          }
          .nocoupon_use {
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(51, 51, 51, 0.18);
            line-height: 12px;
            margin-top: 14px;
          }
        }
      }
    }
  }
  .coupon_warn {
    background: floralwhite;
    border-radius: 0px 0px 8px 8px;
    border: 1px solid floralwhite;
    max-height: 66px;
    padding: 13px 10px 8px 10px;
    box-sizing: border-box;
    margin-top: -5px;
    font-size: 12px;
    line-height: 21px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    p {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .nocoupon_warn {
    background: rgba(249, 249, 249, 1);
    border-radius: 0px 0px 8px 8px;
    border: 1px solid floralwhite;
    max-height: 66px;
    padding: 13px 10px 8px 10px;
    box-sizing: border-box;
    margin-top: -5px;
    font-size: 12px;
    line-height: 21px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    color: rgba(51, 51, 51, 0.3);
    p {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
</style>
